"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ObjectList_1 = require("./_ObjectList");
var _CommonPrefixList_1 = require("./_CommonPrefixList");
exports.ListObjectsV2Output = {
    type: "structure",
    required: [],
    members: {
        IsTruncated: {
            shape: {
                type: "boolean"
            }
        },
        Contents: {
            shape: _ObjectList_1._ObjectList
        },
        Name: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Delimiter: {
            shape: {
                type: "string"
            }
        },
        MaxKeys: {
            shape: {
                type: "integer"
            }
        },
        CommonPrefixes: {
            shape: _CommonPrefixList_1._CommonPrefixList
        },
        EncodingType: {
            shape: {
                type: "string"
            }
        },
        KeyCount: {
            shape: {
                type: "integer"
            }
        },
        ContinuationToken: {
            shape: {
                type: "string"
            }
        },
        NextContinuationToken: {
            shape: {
                type: "string"
            }
        },
        StartAfter: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=ListObjectsV2Output.js.map